<template>
    <el-dialog :title="mainTitle" :visible.sync="editVisible" width="400px" @close="closeEdit" @open="dlgOpen" @closed="dlgClosed" :close-on-click-modal="false" v-loading="loading">
        <span>校区:</span>
        <el-select v-model="huregion" placeholder="请选择" style="width:200px;margin-left:10px">
            <el-option v-for="item in xqqys" :key="item.id" :label="item.name" :value="item.extCode">
            </el-option>
        </el-select>

        <el-button style="margin-left:20px" @click="saves">确认</el-button>
    </el-dialog>
</template>

<script>
import DialogResize from "@/utils/DialogResize.js";
import SettingApi from "@/api/setting.js";
export default {
    mixins: [DialogResize],
    data () {
        return {
            loading: false,
            mainTitle: "设置校区",
            editVisible: false,
            huregion: "",
            xqqys: [],
            ids: "",
            nowParentId: "",
        }
    },
    mounted: function () {
        this.findxqqy();
    },
    methods: {
        init (id, parentid) {
            this.ids = id;
            this.nowParentId = parentid;
            console.log(this.ids);
            this.editVisible = true;
        },
        //校区
        findxqqy () {
            let xqqyCode = 1003;
            SettingApi
                .getClass()
                .Findcode(xqqyCode)
                .then(res2 => {
                    if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                        this.xqqys = res2.data.data;
                            for(let i=0; i<this.xqqys.length; i++){
                                    if(this.xqqys[i].code == '100304'){
                                        this.xqqys.splice(i, 1)
                                    }
                                 }
                        this.loading = false;
                    } else {
                        this.$message.error(res2.data.msg);
                        this.loading = false;
                        return false;
                    }
                })
                .catch(err => {
                    this.loading = false;
                    this.$message.error(err);
                    return false;
                });
        },
        closeEdit () {
            this.huregion = ""
        },
        saves () {
            console.log(this.ids);
            console.log(this.huregion);
            this.ids.huregion = this.huregion
            this.ids.createAt = this.$utils.datetimeparse(new Date(this.ids.createAt), "yyyy-MM-dd");
            let param = this.ids;
            SettingApi.getClass()
                .saveStaff(param)
                .then(res2 => {
                    if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                        this.$message.success("保存成功！");
                        this.loading = false;
                        //关闭弹窗
                        this.editVisible = false;
                        //刷新右边列表数据
                        this.$parent.getListData(this.nowParentId);
                    } else {
                        this.loading = false;
                        this.$message.error(res2.data.msg);
                        return false;
                    }
                })
                .catch(err => {
                    this.loading = false;
                    this.btnDisabled = false;
                    this.$message.error(err);
                    return false;
                });
        },
    }

}
</script>

<style scoped>
</style>